import { type ChangeEvent, useId } from "react";

export function Checkbox({
  checked,
  onChange,
  label,
  description,
  error,
  name,
  disabled = false,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
  error?: string;
  name?: string;
  disabled?: boolean;
}) {
  const id = useId();
  const descriptionId = description ? `${id}-description` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => onChange(event.target.checked);

  return (
    <div className={`ui-checkbox-field${error ? " ui-checkbox-field--error" : ""}`}>
      <label className="ui-checkbox" htmlFor={id}>
        <input
          id={id}
          name={name}
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          aria-invalid={Boolean(error)}
          aria-describedby={errorId ?? descriptionId}
        />
        <span className="ui-checkbox__box" aria-hidden="true">
          <span className="ui-checkbox__mark" />
        </span>
        <span className="ui-checkbox__content">
          <strong>{label}</strong>
          {description ? <span id={descriptionId}>{description}</span> : null}
        </span>
      </label>
      {error ? <span id={errorId} className="ui-field__error">{error}</span> : null}
    </div>
  );
}
